import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { initPostHog } from '@/core/posthog';
import { isNativeShell } from '@/core/capacitor';
import App from './App.tsx';

initPostHog();

document.documentElement.classList.toggle('native-shell', isNativeShell());

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
